import * as CryptoJS from 'crypto-js';
import { Injectable } from '@angular/core';
const SecureStorage = require('secure-web-storage');

@Injectable({
  providedIn: 'root'
})
export class LocalService {
  SECRET_KEY = 'Csm$er1g0';
  constructor() { }
  public secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key) {
      key = CryptoJS.SHA256(key);
      return key.toString();
    },
    encrypt: function encrypt(data) {
      data = CryptoJS.AES.encrypt(data, this.SECRET_KEY);
      data = data.toString();
      return data;
    },
    decrypt: function decrypt(data) {
      data = CryptoJS.AES.decrypt(data, this.SECRET_KEY);
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    }
  });
}